import { useMutation, useQueryClient } from '@tanstack/react-query';
import { directoryApi } from '../client';
import { useSupportAccounts } from './useSupportAccounts';

/**
 * Cancel an app subscription.
 *
 * <p>
 * Invalidates the support-account list, which is where every screen reads the
 * subscription set from — without it the app would still read as live until a
 * reload.
 * </p>
 */
export function useCancelSubscription() {
  const queryClient = useQueryClient();

  return useMutation<string, Error, string>({
    mutationFn: (subscriptionId) => directoryApi.cancelSubscription(subscriptionId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: useSupportAccounts.queryKey });
    },
  });
}
